import { Controller } from "@hotwired/stimulus"

// Copia il testo del target negli appunti e dà un feedback temporaneo.
export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.value)
    const label = this.buttonTarget.textContent
    this.buttonTarget.textContent = "Copiato!"
    setTimeout(() => { this.buttonTarget.textContent = label }, 1500)
  }
}
